import React from "react";
import "../../styles/NavigationSidebar.css";

export default function NavSidebar({ activeNav, setActiveNav }) {
  const navItems = ["Mock Training", "Mock Test", "CRM", "Appointments"];

  return (
    <div className="nav-sidebar">
      <img src="/logo.png" alt="Olumis AI Logo" className="nav-logo" />

      {navItems.map((item) => (
        <button
          key={item}
          className={`nav-button ${activeNav === item ? "active" : ""}`}
          onClick={() => setActiveNav(item)}
        >
          {item}
        </button>
      ))}
    </div>
  );
}